import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { FileCheck, UserCheck, AlertCircle, DollarSign } from "lucide-react";

interface QuickActionsProps {
  onAction: (action: string) => void;
}

const QuickActions = ({ onAction }: QuickActionsProps) => {
  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-200">
      <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Button
          variant="outline"
          className="flex flex-col items-center justify-center h-32 space-y-3 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          onClick={() => onAction("Review Verifications")}
          asChild
        >
          <Link to="/admin/verifications/review">
            <div className="p-2 bg-blue-100 rounded-full">
              <FileCheck className="h-8 w-8" />
            </div>
            <span className="text-base text-center">Review Verifications</span>
          </Link>
        </Button>
        
        <Button
          variant="outline"
          className="flex flex-col items-center justify-center h-32 space-y-3 hover:bg-green-50 hover:text-green-700 transition-colors"
          onClick={() => onAction("User Management")}
          asChild
        >
          <Link to="/admin/users/management">
            <div className="p-2 bg-green-100 rounded-full">
              <UserCheck className="h-8 w-8" />
            </div>
            <span className="text-base text-center">User Management</span>
          </Link>
        </Button>
        
        <Button
          variant="outline"
          className="flex flex-col items-center justify-center h-32 space-y-3 hover:bg-yellow-50 hover:text-yellow-700 transition-colors"
          onClick={() => onAction("Risk Assessment")}
          asChild
        >
          <Link to="/admin/risk/assessment">
            <div className="p-2 bg-yellow-100 rounded-full">
              <AlertCircle className="h-8 w-8" />
            </div>
            <span className="text-base text-center">Risk Assessment</span>
          </Link>
        </Button>
        
        <Button
          variant="outline"
          className="flex flex-col items-center justify-center h-32 space-y-3 hover:bg-purple-50 hover:text-purple-700 transition-colors"
          onClick={() => onAction("Financial Reports")}
          asChild
        >
          <Link to="/admin/finance/reports">
            <div className="p-2 bg-purple-100 rounded-full">
              <DollarSign className="h-8 w-8" />
            </div>
            <span className="text-base text-center">Financial Reports</span>
          </Link>
        </Button>
      </div>
    </Card>
  );
};

export default QuickActions;